module.exports = __webpack_public_path__ + "img/heavyRain.3dcd6ddb.svg";